module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_chubu-2345b78a870729688cfd521b9cd5f0d3.png";